import { CommonModule } from "@angular/common";
import {
  Component,
  DOCUMENT,
  EventEmitter,
  Input,
  Output,
  inject,
} from "@angular/core";
import { SnackBarService } from "@services/snack-bar.service";
import { ButtonComponent } from "../../../../../shared/components/button/button.component";

@Component({
  selector: "app-seller-link-checkout",
  imports: [CommonModule, ButtonComponent],
  templateUrl: "./seller-link-checkout.component.html",
  styleUrl: "./seller-link-checkout.component.scss",
})
export class SellerLinkCheckoutComponent {
  private readonly snackbarService = inject(SnackBarService);
  private readonly document = inject(DOCUMENT);

  @Input() paymentLinkUrl: string | null = null;
  @Input() loading = false;
  @Input() statusPaymentPix = "";
  @Input() isWebSocketConnected = false;
  /** Oculta link e status detalhado quando o conteúdo é exibido no modal. */
  @Input() detailsSuppressed = false;
  @Output() generateLinkClick = new EventEmitter<void>();

  copyLink(): void {
    if (!this.paymentLinkUrl) {
      this.snackbarService.openSnackBar("Erro ao copiar link!", "Fechar", "error");
      return;
    }

    const input = this.document.createElement("input");
    input.style.position = "fixed";
    input.style.opacity = "0";
    input.value = this.paymentLinkUrl;
    this.document.body.appendChild(input);
    input.select();
    input.setSelectionRange(0, 99999);
    this.document.execCommand("copy");
    this.document.body.removeChild(input);

    this.snackbarService.openSnackBar(
      "Link de pagamento copiado com sucesso!",
      "Fechar",
      "success",
    );
  }
}
